import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export class DataLine extends PureComponent {
    render() {
        return (
            <div>
                <P>{this.props.name}</P>
                <Value>
                    <span>{this.props.value || " - "}</span>
                </Value>
            </div>
        );
    }
}

export const P = styled.p`
    font-size: 1em;
    text-align: left;
    width: 49%;
    display: inline-block;
`;

export const Value = styled(P)`
    text-align: right;
`;

DataLine.defaultProps = {
    className: null
};

DataLine.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string
};
